import { ResultadoAnalise } from "./ResultadoAnalise";

export default ResultadoAnalise;